import {
    OrderMapPoint,
    VenueMapPoint,
} from '@/features/orders/components/MapPanel/parts/Content/types'
import type { FeatureCollection, Point } from 'geojson'

export const toMapFeatures = (
    points: (OrderMapPoint | VenueMapPoint)[]
): FeatureCollection<Point> => ({
    type: 'FeatureCollection',
    features: points.map(({ id, coordinate, kind, label }, sortKey) => ({
        type: 'Feature',
        id,
        geometry: { type: 'Point', coordinates: coordinate },
        properties: { id, kind, label, sortKey },
    })),
})
